/**
 * The post-login `?redirect=` target, reduced to a path on this origin.
 *
 * `router.replace` hands anything it does not recognize as a local route to
 * `window.location.href`, so `?redirect=javascript:...` ran script on the
 * app's origin right after login (the Supabase session cookie is readable from
 * JS) and `?redirect=https://evil` was a phishing hop. Only "/" followed by
 * something that is not another slash or backslash passes; browsers also strip
 * tabs/newlines inside URLs ("/\t/evil" becomes "//evil"), so any whitespace or
 * control character is refused too.
 */
export function safeRedirectPath(value: unknown, fallback = "/"): string {
  if (typeof value !== "string") return fallback;
  if (!/^\/(?![\/\\])/.test(value)) return fallback;
  if (/[\s\u0000-\u001f\u007f\\]/.test(value)) return fallback;
  return value;
}
